import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "icon-partner-mercure",
  template: `
    <svg
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
      viewBox="0 0 400.000000 400.000000"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        class="fill-current"
        stroke="none"
        transform="translate(0.000000,400.000000) scale(0.100000,-0.100000)"
      >
        <path
          d="M390 3172 c0 -4 42 -17 93 -29 288 -69 500 -278 606 -601 44 -130 63
        -265 65 -442 l1 -154 57 -34 c32 -19 64 -32 72 -29 7 3 129 214 271 469 141
        255 260 467 264 471 4 4 18 -102 30 -235 31 -329 24 -305 98 -345 52 -29 63
        -32 74 -20 8 8 111 150 229 316 l215 302 7 -43 c57 -327 143 -515 312 -684
        180 -180 405 -275 709 -299 62 -5 77 -3 77 8 0 10 -27 20 -87 32 -359 71 -627
        318 -753 693 -41 121 -60 245 -60 381 l0 117 -45 38 c-25 21 -52 36 -58 33 -7
        -3 -120 -154 -252 -335 -132 -182 -241 -329 -244 -327 -3 4 -60 537 -61 576 0
        17 -110 89 -134 89 -7 0 -118 -192 -246 -427 -129 -236 -241 -440 -250 -455
        -16 -27 -17 -26 -42 100 -51 254 -130 414 -283 568 -141 143 -280 220 -467
        258 -80 17 -198 22 -198 8z"
        />
        <path
          d="M1985 1641 c-62 -28 -115 -104 -115 -166 0 -32 25 -90 53 -122 56
          -64 142 -81 217 -43 48 25 57 38 36 58 -14 15 -19 14 -51 -1 -94 -45 -185 8
          -185 108 0 102 101 158 189 104 31 -19 34 -19 52 -3 24 21 11 39 -46 65 -51
          24 -99 23 -150 0z"
        />
        <path
          d="M390 1469 l0 -180 28 3 27 3 5 130 5 130 71 -130 c39 -71 76 -131 82
          -133 6 -2 44 59 86 135 l75 137 3 -134 3 -135 28 -3 27 -3 0 180 0 181 -37 0
          -38 0 -70 -130 c-38 -72 -72 -130 -75 -130 -3 0 -37 58 -75 130 l-70 130 -37
          0 -38 0 0 -181z"
        />
        <path
          d="M1005 1637 c-3 -7 -4 -87 -3 -177 l3 -165 140 0 c138 0 140 0 143 23
          3 22 2 22 -107 22 l-111 0 0 60 0 60 80 0 c79 0 80 0 80 25 0 25 -1 25 -80 25
          l-80 0 0 45 0 44 108 3 c99 3 107 4 107 23 0 19 -8 20 -138 23 -106 2 -139 0
          -142 -11z"
        />
        <path
          d="M1462 1473 l3 -178 28 -3 27 -3 0 65 0 66 53 0 53 0 32 -65 c29 -58
          35 -65 62 -65 16 0 30 2 30 5 0 3 -15 36 -34 73 -33 65 -33 69 -16 80 29 18
          43 82 28 128 -19 57 -59 74 -176 74 l-92 0 2 -177z m204 102 c8 -10 14 -28 14
          -40 0 -43 -23 -59 -94 -63 l-66 -4 0 67 0 67 66 -4 c50 -3 70 -9 80 -23z"
        />
        <path
          d="M2350 1526 c0 -135 10 -163 73 -210 40 -30 144 -30 183 0 62 46 69
          64 72 205 l4 129 -31 0 -31 0 0 -116 0 -116 -34 -34 c-47 -47 -95 -47 -142 0
          l-34 34 0 116 0 116 -30 0 -30 0 0 -124z"
        />
        <path
          d="M2842 1473 l3 -178 27 -3 c27 -3 27 -2 30 60 l3 63 50 3 50 3 33 -66
          c29 -59 35 -65 62 -65 16 0 30 5 30 10 0 6 -13 37 -30 70 l-30 59 25 37 c43
          64 28 135 -35 166 -26 13 -59 18 -128 18 l-92 0 2 -177z m188 114 c20 -10 25
          -20 25 -52 0 -49 -27 -66 -100 -63 l-50 3 -3 49 c-2 27 -1 55 2 62 7 18 92 18
          126 1z"
        />
        <path
          d="M3290 1470 l0 -180 140 0 140 0 0 25 0 25 -110 0 -110 0 0 60 0 60
          86 0 c83 0 85 1 82 23 -3 20 -9 22 -85 25 l-83 3 0 44 0 45 110 0 110 0 0 25
          0 25 -140 0 -140 0 0 -180z"
        />
        <path
          d="M1284 977 c-10 -27 1 -150 14 -155 8 -2 12 8 12 32 0 36 0 36 45 36
          45 0 45 0 45 -35 0 -24 5 -35 15 -35 12 0 15 16 15 85 0 69 -3 85 -15 85 -10
          0 -15 -11 -15 -35 0 -35 0 -35 -45 -35 -45 0 -45 0 -45 35 0 35 -16 48 -26 22z"
        />
        <path
          d="M1574 966 c-60 -51 -21 -146 58 -146 52 0 88 35 88 85 0 76 -87 112
          -146 61z m100 -22 c47 -47 -14 -126 -70 -90 -31 21 -39 52 -20 81 19 29 66 34
          90 9z"
        />
        <path
          d="M1820 975 c0 -10 10 -15 30 -15 l30 0 0 -70 c0 -40 4 -70 10 -70 6 0
          10 30 10 70 l0 70 30 0 c20 0 30 5 30 15 0 12 -14 15 -70 15 -56 0 -70 -3 -70
          -15z"
        />
        <path
          d="M2080 905 l0 -85 60 0 c33 0 60 4 60 10 0 6 -20 10 -45 10 -41 0 -45
          2 -45 25 0 23 4 25 40 25 29 0 40 4 40 15 0 11 -11 15 -40 15 -33 0 -40 3 -40
          20 0 17 7 20 45 20 33 0 45 4 45 15 0 12 -13 15 -60 15 l-60 0 0 -85z"
        />
        <path
          d="M2340 905 l0 -85 55 0 c30 0 55 5 55 10 0 6 -18 10 -40 10 l-40 0 0
          75 c0 60 -3 75 -15 75 -12 0 -15 -16 -15 -85z"
        />
        <path
          d="M2568 979 c-21 -12 -24 -52 -5 -66 6 -6 26 -15 42 -20 17 -5 31 -17
          33 -25 4 -21 -31 -32 -57 -19 -21 12 -37 -1 -26 -19 10 -16 91 -12 105 4 22
          28 8 60 -37 81 -62 28 -54 60 11 48 22 -4 27 -2 24 8 -6 17 -67 23 -90 8z"
        />
      </g>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconPartnerMercureComponent {}
